import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-confidentialite',
  imports: [RouterModule],
  templateUrl: './confidentialite.component.html',
  styleUrl: './confidentialite.component.css',
})
export class ConfidentialiteComponent {}